// RelevantItemsList — Linked papers/patents with source preview
import { FileText, ExternalLink } from 'lucide-react'
import type { CrmRelevantItem } from '../../types'

const TYPE_COLORS = {
  paper: 'bg-blue-50 text-blue-600',
  patent: 'bg-amber-50 text-amber-600',
  journal: 'bg-green-50 text-green-600',
}

interface Props {
  items: CrmRelevantItem[]
}

export default function RelevantItemsList({ items }: Props) {
  if (items.length === 0) {
    return <p className="text-sm text-gray-500 text-center py-8">No linked items</p>
  }

  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={item.item_id} className="bg-white border rounded-lg p-3 flex items-start gap-3">
          <div className={`w-8 h-8 rounded flex items-center justify-center flex-shrink-0 ${TYPE_COLORS[item.source_type] || 'bg-gray-50 text-gray-600'}`}>
            <FileText size={14} />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2">
              <span className="text-xs font-medium uppercase px-1.5 py-0.5 rounded bg-gray-100 text-gray-500">{item.source_type}</span>
              <p className="text-sm font-medium text-gray-900 truncate">{item.source_title || 'Untitled'}</p>
            </div>
            {item.source_authors?.length > 0 && (
              <p className="text-xs text-gray-500 mt-0.5">{item.source_authors.slice(0, 3).join(', ')}</p>
            )}
            {item.relevance_note && <p className="text-xs text-gray-500 mt-1">{item.relevance_note}</p>}
          </div>
          {item.source_id && (
            <ExternalLink size={14} className="text-gray-500 flex-shrink-0 mt-1" />
          )}
        </div>
      ))}
    </div>
  )
}
